import { createEffect, createStore } from "effector"

import { ApiLinkEntity, ApiLinkRel, ApiServiceName } from "config/constants"
import ExchangeRate, { getExchangeRateID, IGetExchangeRateDto, IGetExchangeRateRequest } from "models/ExchangeRate"
import CustomError from "models/CustomError"
import ApiService from "services/ApiService"
import ErrorHandler from "utils/errorHandler"
import { uniqBy } from "lodash"

export const $exchangeRates = createStore<Map<string, ExchangeRate>>(new Map())

export const fetchExchangeRates = createEffect<IGetExchangeRateRequest[], ExchangeRate[] | void, CustomError>(async (data) => {
    const cache = $exchangeRates.getState()
    const ratesToFetch = uniqBy(
        data.filter(rate => !cache.has(getExchangeRateID({ date: rate.date, currency: rate.currency }))),
        r => getExchangeRateID({ date: r.date, currency: r.currency }),
    )

    if (ratesToFetch.length === 0) {
        return
    }

    try {
        const resp: IGetExchangeRateDto[] = await ApiService.request({
            serviceName: ApiServiceName.asset,
            followLink: {
                entity: ApiLinkEntity.exchangeRate,
                rel: ApiLinkRel.all,
            },
            data: ratesToFetch.map(r => ExchangeRate.getRequestDto(r)),
        })
        return resp.map(dto => new ExchangeRate(dto))
    } catch(e) {
        ErrorHandler.handleHttpError(e)
    }
})

$exchangeRates.on(fetchExchangeRates.doneData, (state, payload) => {
    if (!payload) return state
    const newState = new Map(state)
    payload.forEach(rate => {
        newState.set(getExchangeRateID({ date: rate.date, currency: rate.currency }), rate)
    })
    return newState
})

export function applyExchangeRate(price: number, rate: number) {
    if (rate === 0) return 0
    return price / rate
}
